export default __webpack_public_path__ + "static/media/super-search-img.f4e5f890.svg";